import React, { useEffect, useState } from "react";
import axios from "axios";
import { Link, useHistory } from "react-router-dom";
import { connect } from "react-redux";
import { loadCss, filterDataTableBySearchValue, forceRound, formatDateToTime, reduceCharacter, getLowerCaseString, truncateString, showDatePassed, localize } from "../../helpers/function";
import LoadingTable from "../components/LoadingTable";
import appConfig from "../../config/appConfig";
import Pagination from "../components/Pagination";
import EmptyTable from "../components/EmptyTable";
import HeaderTablePage from "../components/HeaderTablePage";
import InfirmationTable from "../components/InfirmationTable";
import { ERROR_401 } from "../../config/errorPage";
import { verifyPermission } from "../../helpers/permission";
import { verifyTokenExpire } from "../../middleware/verifyToken";
import HtmlDescription from "../components/DescriptionDetail/HtmlDescription";
import HtmlDescriptionModal from "../components/DescriptionDetail/HtmlDescriptionModal";
import { useTranslation } from "react-i18next";
import IncompleteClaimHistoryDrawer from "../components/IncompleteClaimHistoryDrawer";
import { NUMBER_ELEMENT_PER_PAGE } from "../../constants/dataTable";
import ls from "localstorage-slim";

loadCss("/assets/plugins/custom/datatables/datatables.bundle.css");

const endPointConfig = {
  PRO: {
    plan: "PRO",
    list: `${appConfig.apiDomaine}/my/claims-incompletes`,
    destroy: (claimId) =>
      `${appConfig.apiDomaine}/my/claims-incompletes/${claimId}`,
  },
  MACRO: {
    holding: {
      list: `${appConfig.apiDomaine}/any/claims-incompletes`,
      destroy: (claimId) =>
        `${appConfig.apiDomaine}/any/claims-incompletes/${claimId}`,
    },
    filial: {
      list: `${appConfig.apiDomaine}/my/claims-incompletes`,
      destroy: (claimId) =>
        `${appConfig.apiDomaine}/my/claims-incompletes/${claimId}`,
    },
  },
  HUB: {
    plan: "HUB",
    list: `${appConfig.apiDomaine}/without-client/claims-incompletes `,
    destroy: (claimId) =>
      `${appConfig.apiDomaine}/without-client/claims-incompletes/${claimId}`,
  },
};

const IncompleteClaims = (props) => {
  //usage of useTranslation i18n
  const { t, ready } = useTranslation();

  document.title =
    "Satis client - " + (ready ? t("Liste plaintes incomplètes") : null);
  if (
    !(
      verifyPermission(
        props.userPermissions,
        "list-claim-incomplete-against-any-institution"
      ) ||
      verifyPermission(
        props.userPermissions,
        "list-claim-incomplete-against-my-institution"
      ) ||
      verifyPermission(
        props.userPermissions,
        "list-claim-incomplete-without-client"
      )
    )
  )
    window.location.href = ERROR_401;

  const history = useHistory();
  const [load, setLoad] = useState(true);
  const [numberPage, setNumberPage] = useState(0);
  const [totalData, setTotalData] = useState(0);
  const [searchable, setSearchable] = useState("");
  const [showList, setShowList] = useState([]);
  const [numberPerPage, setNumberPerPage] = useState(10);
  const [activeNumberPage, setActiveNumberPage] = useState(1);
  const [nextUrl, setNextUrl] = useState(null);
  const [prevUrl, setPrevUrl] = useState(null);
  const [currentMessage, setCurrentMessage] = useState("");
  const [historyClaim, setHistoryClaim] = useState(null);
  let temp = JSON.parse(ls.get("userData"));
  let type_macro = temp.data.identite.staff.institution.institution_type?.name;

  let endPoint = "";
  if (props.plan === "MACRO") {
    if (
      verifyPermission(
        props.userPermissions,
        "list-claim-incomplete-against-any-institution"
      )
    )
      endPoint = endPointConfig[props.plan].holding;
    else if (
      verifyPermission(
        props.userPermissions,
        "list-claim-incomplete-against-my-institution"
      )
    )
      endPoint = endPointConfig[props.plan].filial;
  } else endPoint = endPointConfig[props.plan];

  const fetchClaims = () => {
    if (verifyTokenExpire()) {
      const params = {
        page: activeNumberPage,
        size: numberPerPage,
      }
      if(searchable?.length > 0) params['key'] = searchable;

      axios
        .get(endPoint.list, {
          params: params
        })
        .then((response) => {
          setLoad(false);
          setShowList(response.data.data);
          setTotalData(response.data.total);
          setNumberPage(response.data.last_page);
          setPrevUrl(response.data.prev_page_url);
          setNextUrl(response.data.next_page_url);
        })
        .catch((error) => {
          setLoad(false);
        });
    }
  }

  useEffect(() => {
      fetchClaims();
  }, [searchable, numberPerPage, activeNumberPage, numberPage]);

  useEffect(() => {
    setActiveNumberPage(1);
  }, [ searchable]);

  const searchElement = async (e) => {
    setSearchable(e.target.value);
  };

  const onChangeNumberPerPage = (e) => {
    setActiveNumberPage(1);
    setNumberPerPage(parseInt(e.target.value));
  };


  const onClickPage = (e, page) => {
    e.preventDefault();
    setActiveNumberPage(page);
  };

  const onClickNextPage = (e) => {
    e.preventDefault();
    if (activeNumberPage <= numberPage && nextUrl !== null) {
      setActiveNumberPage(activeNumberPage + 1);
    }
  };

  const onClickPreviousPage = (e) => {
    e.preventDefault();
    if (activeNumberPage >= 1 && prevUrl !== null) {
      setActiveNumberPage(activeNumberPage - 1);
    }
  };

  const pages = (() => {
    const nb_p = [];
    for (let i = 0; i < numberPage; i++) {
      nb_p[i] = i;
    }
    return nb_p;
  })()

  const showModal = (message) => {
    setCurrentMessage(message);
    document.getElementById("button_modal").click();
  };

  const printBodyTable = (claim, index) => {
    return (
      <tr key={index} role="row" className="odd">
        <td>{claim.reference ? claim.reference : ""}</td>
        <td>
          {claim.claimer?.raison_sociale
            ? claim.claimer?.raison_sociale
            : (claim.claimer?.lastname ? claim.claimer.lastname : "") +
              " " +
              (claim.claimer?.firstname ? claim.claimer.firstname : "")}

          {claim.account_targeted
            ? " / " + claim.account_targeted.number
            : claim.account_number
            ? " / " + claim.account_number
            : ""}
        </td>
        <td>
          {verifyPermission(
            props.userPermissions,
            "show-claim-incomplete-against-any-institution"
          ) ||
          verifyPermission(
            props.userPermissions,
            "show-claim-incomplete-without-client"
          )
            ? claim.institution_targeted
              ? claim.institution_targeted.name !== null
                ? claim.institution_targeted.name
                : ""
              : "-"
            : claim.unit_targeted
            ? claim.unit_targeted.name !== null
              ? localize(claim.unit_targeted.name)
              : ""
            : "-"}
        </td>
        <td>
          {formatDateToTime(claim.received_at)} <br />
          {showDatePassed(claim)}
        </td>
        <td>
          {formatDateToTime(claim.created_at)}
        </td>
        <td>
          {claim.claim_object
            ? claim.claim_object.name
              ? localize(claim.claim_object.name)
              : "-    "
            : "- "}
        </td>
        <td style={{ textAlign: "center" }}>
          <HtmlDescription
            onClick={() =>
              showModal(claim.description ? claim.description : "-")
            }
          />
          {/*{claim.description.length > 30 ? reduceCharacter(claim.description) : claim.description}*/}
        </td>
        <td style={{ textAlign: "center" }}>
          {verifyPermission(
            props.userPermissions,
            "show-claim-incomplete-against-any-institution"
          ) ||
          verifyPermission(
            props.userPermissions,
            "show-claim-incomplete-against-my-institution"
          ) ||
          verifyPermission(
            props.userPermissions,
            "show-claim-incomplete-without-client"
          ) ? (
            <Link
              to={`/process/incomplete_claims/edit/${claim.id}`}
              className="btn btn-sm btn-clean btn-icon btn-icon-md"
              title={t("Modifier")}
            >
              <i className="la la-edit" />
            </Link>
          ) : null}
          {/* BOUTON HISTORIQUE & RELANCES */}
          <button
            type="button"
            className="btn btn-sm btn-clean btn-icon btn-icon-md"
            title={t("Historique & Relances")}
            onClick={() => setHistoryClaim(claim)}
          >
            <i className="la la-history text-info" />
          </button>
        </td>
      </tr>
    );
  };

  return ready ? (
    verifyPermission(
      props.userPermissions,
      "list-claim-incomplete-against-any-institution"
    ) ||
    verifyPermission(
      props.userPermissions,
      "list-claim-incomplete-against-my-institution"
    ) ||
    verifyPermission(
      props.userPermissions,
      "list-claim-incomplete-without-client"
    ) ? (
      <div
        className="kt-content  kt-grid__item kt-grid__item--fluid kt-grid kt-grid--hor"
        id="kt_content"
      >
        <div className="kt-subheader  kt-grid__item" id="kt_subheader">
          <div className="kt-container  kt-container--fluid">
            <div className="kt-subheader__main">
              <h3 className="kt-subheader__title">{t("Collecte")}</h3>
              <span className="kt-subheader__separator kt-hidden" />
              <div className="kt-subheader__breadcrumbs">
                <span className="kt-subheader__separator kt-hidden" />
                <div className="kt-subheader__breadcrumbs">
                  <a href="#icone" className="kt-subheader__breadcrumbs-home">
                    <i className="flaticon2-shelter" />
                  </a>
                  <span className="kt-subheader__breadcrumbs-separator" />
                  <a
                    href="#button"
                    onClick={(e) => e.preventDefault()}
                    className="kt-subheader__breadcrumbs-link"
                    style={{ cursor: "default" }}
                  >
                    {t("Réclamations Incomplètes")}
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="kt-container  kt-container--fluid kt-grid__item kt-grid__item--fluid">
          <InfirmationTable
            information={t("Liste des réclamations incomplètes")}
          />

          <div className="kt-portlet">
            {/*<HeaderTablePage
              addPermission={""}
              title={t("Réclamations Incomplètes")}
              addText={t("Ajouter de réclamations")}
              addLink={"/settings/claims/add"}
            />*/}
            <div className="kt-portlet__body">
              <div className="row">
                <div className="col-sm-6 text-left">
                  <div id="kt_table_1_filter" className="dataTables_filter">
                    <label>
                      {t("Recherche")}:
                      <input
                        id="myInput"
                        type="text"
                        onKeyUp={(e) => searchElement(e)}
                        className="form-control form-control-sm"
                        placeholder=""
                        aria-controls="kt_table_1"
                      />
                    </label>
                  </div>
                </div>
              </div>
            </div>
            {load ? (
              <LoadingTable />
            ) : (
              <div className="kt-portlet__body">
                <div
                  id="kt_table_1_wrapper"
                  className="dataTables_wrapper dt-bootstrap4"
                >
                  <div className="row">
                    <div className="col-sm-12">
                      <table
                        className="table table-striped table-bordered table-hover table-checkable dataTable dtr-inline"
                        id="myTable"
                        role="grid"
                        aria-describedby="kt_table_1_info"
                        style={{ width: "952px" }}
                      >
                        <thead>
                          <tr role="row">
                            <th
                              className="sorting"
                              tabIndex="0"
                              aria-controls="kt_table_1"
                              rowSpan="1"
                              colSpan="1"
                              style={{ width: "25px" }}
                              aria-label="Ship City: activate to sort column ascending"
                            >
                              {t("Référence")}
                            </th>
                            <th
                              className="sorting"
                              tabIndex="0"
                              aria-controls="kt_table_1"
                              rowSpan="1"
                              colSpan="1"
                              style={{ width: "85px" }}
                              aria-label="Ship City: activate to sort column ascending"
                            >
                              {t("Réclamant")}
                            </th>
                            <th
                              className="sorting"
                              tabIndex="0"
                              aria-controls="kt_table_1"
                              rowSpan="1"
                              colSpan="1"
                              style={{ width: "50px" }}
                              aria-label="Ship City: activate to sort column ascending"
                            >
                              {verifyPermission(
                                props.userPermissions,
                                "show-claim-incomplete-against-any-institution"
                              ) ||
                              verifyPermission(
                                props.userPermissions,
                                "show-claim-incomplete-without-client"
                              )
                                ? t("Institution concernée")
                                : t("Point de service visé")}
                            </th>

                            <th
                              className="sorting sorter-dates"
                              tabIndex="0"
                              aria-controls="kt_table_1"
                              rowSpan="1"
                              colSpan="1"
                              style={{ width: "50px" }}
                              aria-label="Ship City: activate to sort column ascending"
                            >
                              {t("Date de réception")}
                            </th>
                            <th
                              className="sorting sorter-dates"
                              tabIndex="0"
                              aria-controls="kt_table_1"
                              rowSpan="1"
                              colSpan="1"
                              style={{ width: "50px" }}
                              aria-label="Country: activate to sort column ascending"
                            >
                              {t("Date de création")}
                            </th>
                            <th
                              className="sorting"
                              tabIndex="0"
                              aria-controls="kt_table_1"
                              rowSpan="1"
                              colSpan="1"
                              style={{ width: "85px" }}
                              aria-label="Ship City: activate to sort column ascending"
                            >
                              {t("Objet de réclamation")}
                            </th>
                            <th
                              className="sorting"
                              tabIndex="0"
                              aria-controls="kt_table_1"
                              rowSpan="1"
                              colSpan="1"
                              style={{ width: "100px" }}
                              aria-label="Ship City: activate to sort column ascending"
                            >
                              {t("Description")}
                            </th>

                            <th
                              className="sorting"
                              tabIndex="0"
                              aria-controls="kt_table_1"
                              rowSpan="1"
                              colSpan="1"
                              style={{ width: "70.25px" }}
                              aria-label="Type: activate to sort column ascending"
                            >
                              {t("Action")}
                            </th>
                          </tr>
                        </thead>
                        <tbody>
                          {showList.length > 0 ? (
                            showList.map((claim, index) =>
                              printBodyTable(claim, index)
                            )
                          ) : (
                            <EmptyTable />
                          )}
                        </tbody>
                        <tfoot>
                          <tr>
                            <th rowSpan="1" colSpan="1">
                              {t("Référence")}
                            </th>
                            <th rowSpan="1" colSpan="1">
                              {t("Réclamant")}
                            </th>
                            <th rowSpan="1" colSpan="1">
                              {props.plan === "PRO" || type_macro === "filiale"
                                ? t("Point de service visé")
                                : t("Institution ciblée")}
                            </th>

                            <th rowSpan="1" colSpan="1">
                              {t("Date de réception")}
                            </th>
                            <th rowSpan="1" colSpan="1">
                              {t("Date de création")}
                            </th>
                            <th rowSpan="1" colSpan="1">
                              {t("Objet de réclamation")}
                            </th>
                            <th rowSpan="1" colSpan="1">
                              {t("Description")}
                            </th>
                            <th rowSpan="1" colSpan="1">
                              {t("Action")}
                            </th>
                          </tr>
                        </tfoot>
                      </table>
                      <button
                        id="button_modal"
                        type="button"
                        className="btn btn-secondary btn-icon-sm d-none"
                        data-toggle="modal"
                        data-target="#message_email"
                      />
                      <HtmlDescriptionModal
                        title={t("Description")}
                        message={currentMessage}
                      />

                      {/* TIROIR LATÉRAL D'HISTORIQUE & RELANCES */}
                      <IncompleteClaimHistoryDrawer
                        claim={historyClaim}
                        show={!!historyClaim}
                        onClose={() => setHistoryClaim(null)}
                        onOpenFollowUpModal={(claimToFollowUp) => {
                          history.push(`/process/incomplete_claims/edit/${claimToFollowUp.id}`);
                        }}
                      />
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-sm-12 col-md-5">
                      <div
                        className="dataTables_info"
                        id="kt_table_1_info"
                        role="status"
                        aria-live="polite"
                      >
                        {t("Affichage de")} {showList.length}{" "}
                        {t("sur")} {totalData} {t("données")}
                      </div>
                    </div>
                    {!searchable ? (
                      <div className="col-sm-12 col-md-7 dataTables_pager">
                        <Pagination
                          numberPerPage={numberPerPage}
                          onChangeNumberPerPage={onChangeNumberPerPage}
                          activeNumberPage={activeNumberPage}
                          onClickPreviousPage={(e) => onClickPreviousPage(e)}
                          pages={pages}
                          onClickPage={(e, number) => onClickPage(e, number)}
                          numberPage={numberPage}
                          onClickNextPage={(e) => onClickNextPage(e)}
                        />
                      </div>
                    ) : null}
                  </div>
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
    ) : null
  ) : null;
};
const mapStateToProps = (state) => {
  return {
    userPermissions: state.user.user.permissions,
    plan: state.plan.plan,
  };
};

export default connect(mapStateToProps)(IncompleteClaims);
